import "../App.css";
import "../styles/tabStyle.css";
import Sidebar from "./Sidebar";
import "../styles/login.css";
import { withRouter } from "react-router-dom";
import AutocompleteForms from "./AutocompleteForms";
import React, { useState, useEffect } from "react";
import Parametros from "./Parametros";
import Table from "./Table";
import UserTab from "./UserTab";
import CrearCausa from "./Operaciones/CrearCausa";
import CurrentUser from "./CurrentUser";

function TraspasoDeudas(props) {
  const [listaCausas, setListaCausas] = useState([]);
  // eslint-disable-next-line
  const [listaCausasUpdate, setListaCausasUpdate] = useState([]);
  const [buscarState, setBuscarState] = useState(true);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  // eslint-disable-next-line
  const [update, setUpdate] = useState(false);
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  const [paginas, setPaginas] = useState(0);
  const [formularioUpdate, setformularioUpdate] = useState({});

  const [listTribunales, setTribunales] = useState([]);
  const [Empresa, setEmpresas] = useState([]);
  const [rolTribunal, setRolTribunal] = useState([]);
  const [deudores, setDeudores] = useState([]);
  // eslint-disable-next-line
  const [tipoState, setTipos] = useState([]);

  const [origen, setOrigen] = useState(null);
  const [destino, setDestino] = useState(null);

  const { history } = props;

  const defaultValue = { value: "", label: "Todos" };
  useEffect(() => {
    async function llamadaApi() {
      let responseDeudores = await fetch(Parametros.post + "debts", {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      });
      let responseJsonDeudores = await responseDeudores.json();
      if (responseDeudores.status === 200 || responseDeudores.status === 201) {
        setDeudores(responseJsonDeudores);
      } else if (responseDeudores.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }

      try {
        let responseTribunal = await fetch(Parametros.urlApi + "courts", {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });

        if (
          responseTribunal.status === 200 ||
          responseTribunal.status === 201
        ) {
          let responseJsonTribunal = await responseTribunal.json();
          setTribunales(responseJsonTribunal);
        }

        let responseRolTribunal = await fetch(
          Parametros.urlApi + "court_roles?skip=0&limit=100",
          {
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
          }
        );
        if (
          responseRolTribunal.status === 200 ||
          responseRolTribunal.status === 201
        ) {
          let responseJsonRolTribunal = await responseRolTribunal.json();
          setRolTribunal(responseJsonRolTribunal);
        }

        let responseEmpresas = await fetch(Parametros.urlApi + "companies", {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });

        if (
          responseEmpresas.status === 200 ||
          responseEmpresas.status === 201
        ) {
          let responseJsonEmpresas = await responseEmpresas.json();
          setEmpresas(responseJsonEmpresas);
        }

        let responseTipo = await fetch(
          Parametros.urlApi + "process_types?skip=0&limit=100",
          {
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
          }
        );

        if (responseTipo.status === 200 || responseTipo.status === 201) {
          let responseJsonTipo = await responseTipo.json();
          setTipos(responseJsonTipo);
        }
      } catch {}
    }
    llamadaApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    buscarCausa();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginacionState]);

  const [formularioBuscado, setFormularioBuscado] = useState({
    tipoCausa: "",
    tribunal: "",
    rolTribunal: "",
    empresa: "",
    rolDeudor: "",
    nOperacion: "",
    strategy: "",
    rol: "",
  });

  const handleInputChange = (e, autocomplete) => {
    const value = e.target.value ? e.target.value : e.currentTarget.innerText;
    const name = e.target.getAttribute("name");

    setFormularioBuscado({
      ...formularioBuscado,
      [name]: value,
    });
  };

  let buscarCausa = async (event, fromButton = false) => {
    if (event) {
      event.preventDefault();
    }

    const formularioToSend = {
      ...formularioBuscado,
      empresa: formularioBuscado.empresa.split("-")[0],
      rit: formularioBuscado.rolTribunal,
    };

    //
    let skip;
    if (fromButton) {
      skip = 1;
      setPaginacionState({ ...paginacionState, skip: 1 });
      setUpdate(!update);
    } else {
      skip = paginacionState.skip;
    }
    //
    //   "url to fetch:",
    //   `${Parametros.post}coll_process?skip=${skip}&limit=${paginacionState.limit}`
    // );
    let response = await fetch(
      `${Parametros.post}coll_process?skip=${skip}&limit=${paginacionState.limit}`,
      {
        method: "POST",

        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
        body: JSON.stringify(formularioToSend),
      }
    );
    let responseJSON = await response.json();
    console.log({ responseJSON });
    if (response.status === 200 || response.status === 201) {
      setListaCausas(responseJSON.data);
      setListaCausasUpdate(responseJSON.data);

      // setPaginas(responseJson.n_pages)
      setPaginas(responseJSON.n_pages);
      setBuscarState(true);
    } else {
      alert(responseJSON.detail);
    }
  };

  let administrarCausa = (item) => {
    localStorage.setItem("item", JSON.stringify(item));
    history.push({
      pathname: "/AdministracionCausas",
    });
  };

  const [modalState, setModalState] = useState(false);

  let ModalConfig = () => {
    setModalState(!modalState);
  };

  const handleCambioDeuda = async () => {
    if (!origen || !destino) {
      return alert("Debe seleccionar una deuda origen y destino");
    }
    if (
      window.confirm(
        `Vas a traspasar la deuda con id: ${origen} a la deuda con id: ${destino}, ¿Estás seguro?`
      )
    ) {
      const request = {
        coll_proc_origin: origen,
        coll_proc_destination: destino,
      };

      let response = await fetch(`${Parametros.post}coll_proc/debts`, {
        method: "PUT",

        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
        body: JSON.stringify(request),
      });
      if (response.status === 200 || response.status === 201) {
        alert("Deuda traspasada correctamente");
        setOrigen(null);
        setDestino(null);
        buscarCausa();
      } else {
        alert("Error al cambiar deuda");
      }
    }
  };

  const handleSetOrigen = (id) => {
    if (id === destino) {
      setDestino(null);
    }
    setOrigen(id);
  };

  const handleSetDestino = (id) => {
    if (id === origen) {
      setOrigen(null);
    }
    setDestino(id);
  };

  return (
    <div className="App">
      <CrearCausa
        modalCondig={ModalConfig}
        tipoState={tipoState}
        courtRole={rolTribunal}
        acreedores={Empresa}
        deudores={deudores}
        listTribunales={listTribunales}
        setModal={setModalState}
        modalState={modalState}
      ></CrearCausa>

      <Sidebar tipo="1"></Sidebar>
      <br />
      <UserTab nombre={"Traspaso de Deudas"}></UserTab>
      <div className="container">
        <div className="col-md-12">
          {formularioBuscado && (
            <form id="formularioBusqueda">
              <div className="col-md-3">
                <h5>Acreedor</h5>
                <AutocompleteForms
                  personalHandleChange={handleInputChange}
                  nameElement={"empresa"}
                  formularioBuscado={formularioBuscado}
                  setformulario={setFormularioBuscado}
                  value={formularioBuscado.empresa}
                  key={update}
                  suggestions={[
                    defaultValue,
                    ...Empresa.map((item) => {
                      return {
                        value: item.rut,
                        label: item.name + "/" + item.rut,
                      };
                    }),
                  ]}
                />
              </div>

              <div className="col-md-3">
                <h5>Deudor</h5>
                <AutocompleteForms
                  personalHandleChange={handleInputChange}
                  nameElement={"rolDeudor"}
                  formularioBuscado={formularioBuscado}
                  setformulario={setFormularioBuscado}
                  key={update}
                  value={formularioBuscado.rolDeudor}
                  suggestions={[
                    defaultValue,
                    ...deudores.map((item) => {
                      return {
                        value: item.value.split("/")[0].split("-")[0],
                        label: item.value,
                      };
                    }),
                  ]}
                />
              </div>

              <div className="col-md-3">
                <h5>Tribunal</h5>
                <AutocompleteForms
                  personalHandleChange={handleInputChange}
                  nameElement={"tribunal"}
                  formularioBuscado={formularioBuscado}
                  setformulario={setFormularioBuscado}
                  key={update}
                  value={formularioBuscado.tribunal}
                  suggestions={[
                    defaultValue,
                    ...listTribunales.map((item) => {
                      return { value: item.name, label: item.name };
                    }),
                  ]}
                />
              </div>

              <div className="col-md-3">
                <h5>RIT</h5>
                <AutocompleteForms
                  personalHandleChange={handleInputChange}
                  nameElement={"rolTribunal"}
                  formularioBuscado={formularioBuscado}
                  setformulario={setFormularioBuscado}
                  key={update}
                  value={formularioBuscado.rolTribunal}
                  suggestions={[
                    defaultValue,
                    ...rolTribunal.map((item) => {
                      return { value: item.name, label: item.name };
                    }),
                  ]}
                />
              </div>

              <div className="col-md-3">
                <h5>Tipo de causa</h5>
                <AutocompleteForms
                  personalHandleChange={handleInputChange}
                  nameElement={"tipoCausa"}
                  formularioBuscado={formularioBuscado}
                  setformulario={setFormularioBuscado}
                  key={update}
                  value={formularioBuscado.tipoCausa}
                  suggestions={[
                    defaultValue,
                    ...tipoState.map((item) => {
                      return {
                        value: item.coll_proc_type_id,
                        label: item.name,
                      };
                    }),
                  ]}
                />
              </div>

              <div className="col-md-3">
                <h5>N° Operación</h5>
                <input
                  onChange={handleInputChange}
                  name={"nOperacion"}
                  className="form-control"
                ></input>
              </div>

              <div className="col-md-3">
                <h5>Estrategia</h5>
                <input
                  onChange={handleInputChange}
                  name={"strategy"}
                  className="form-control"
                ></input>
              </div>

              <div className="col-md-3">
                <h5>Rol</h5>
                <input
                  onChange={handleInputChange}
                  name={"rol"}
                  className="form-control"
                  placeholder="123-2020"
                ></input>
              </div>

              <div className="col-md-3">
                <br />
                <button
                  type="button"
                  onClick={(e) => {
                    buscarCausa(e, true);
                  }}
                  style={{ margin: "14px 0px" }}
                  className="form-control button brEdit btn-primary"
                >
                  Buscar
                </button>
              </div>
            </form>
          )}
        </div>

        {buscarState && (
          <div className="col-md-12 table-responsive" style={{ width: "100%" }}>
            <Table
              key={update}
              type={1}
              paginationBelow={true}
              extraAction={
                <button
                  type="button"
                  onClick={handleCambioDeuda}
                  className="btn btn-primary traspasarDeudasBtn"
                >
                  Traspasar deudas
                </button>
              }
              paginas={paginas}
              paginadorState={paginacionState}
              setPaginadoor={setPaginacionState}
              sinGestion
              elementos={[
                "Tipo de causa",
                "Rol",
                "Tribunal",
                "Estado",
                "Rut Acreedor",
                "Acreedor",
                "Rut Deudor",
                "Deudor",
                "Estrategia",
                "N° Operación",
                "Monto deuda",
                "Origen",
                "Destino",
              ]}
            ></Table>
            <table
              className="table table-bordered table-responsive"
              id="myTable"
            >
              <Table
                type={2}
                sinGestion
                elementos={[
                  "Tipo de causa",
                  "Rol",
                  "Tribunal",
                  "Estado",
                  "Rut Acreedor",
                  "Acreedor",
                  "Rut Deudor",
                  "Deudor",
                  "Estrategia",
                  "N° Operación",
                  "Monto deuda",
                  "Origen",
                  "Destino",
                ]}
              ></Table>
              <tbody className="ajusteTabladata">
                {/* {usuario.modulos.indexOf("Causas") > -1 && usuario.permisos.indexOf("Ver") > -1 ? */}
                {usuario.permisos.indexOf("Ver") > -1 ? (
                  listaCausas.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.coll_proc_id}</td>
                        <td>{item.tipo_causa} </td>
                        <td>{item.rol_tribunal + "-" + item.rol}</td>
                        <td>{item.nombre_tribunal}</td>
                        <td>{item.state_name}</td>
                        <td>
                          {item.rut_creditor}-{item.rut_creditor_id}
                        </td>
                        <td>{item.empresa}</td>
                        <td>{item.rut_deudor + "-" + item.rut_deudor_id}</td>
                        <td>{item.nombre_deudor}</td>
                        <td>{item.strategy}</td>
                        <td>{item.n_operation}</td>
                        <td>{item.amount}</td>
                        <td>
                          <input
                            type="radio"
                            name="origen"
                            checked={item.coll_proc_id === origen}
                            onChange={() => handleSetOrigen(item.coll_proc_id)}
                          />
                        </td>
                        <td>
                          <input
                            type="radio"
                            name="destino"
                            checked={item.coll_proc_id === destino}
                            onChange={() => handleSetDestino(item.coll_proc_id)}
                          />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <h1>no tiene permisos para ver las causa</h1>
                )}
              </tbody>
            </table>
            <Table
              type={3}
              paginas={paginas}
              paginadorState={paginacionState}
              setPaginadoor={setPaginacionState}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default withRouter(TraspasoDeudas);
